// CustomModal.js
import React from 'react';
import { Modal, Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';



const CustomModal = ({ open, handleClose, title, children, noCancelBtn, paddingDelete }) => {

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 24,
  p: paddingDelete || 4,
  
};


  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography sx={{ textAlign: 'center' }}  variant="h6">{title}</Typography>
           {!noCancelBtn && 
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>}
        </Box>
        {children}
      </Box>
    </Modal>
  );
};

export default CustomModal;
